import type { IconName } from '@masar/ui';
import type { Perm } from './permissions';

export type NavGroup = 'ops' | 'mgmt';

export interface NavItem {
  key: string;
  path: string;
  /** Arabic source label (translated with t()). */
  label: string;
  icon: IconName;
  group: NavGroup;
  /** Visible when the member holds any of these. */
  perms: readonly Perm[];
}

/** The prototype's workspace views (VIEWS in app.js), in the same order, plus Customers. */
export const NAV: readonly NavItem[] = [
  { key: 'today', path: '/today', label: 'اليوم', icon: 'home', group: 'ops', perms: ['p.today'] },
  {
    key: 'calendar',
    path: '/calendar',
    label: 'تقويم الحجوزات',
    icon: 'cal',
    group: 'ops',
    perms: ['p.calendar'],
  },
  { key: 'walkin', path: '/walk-in', label: 'حجز حضوري', icon: 'plus', group: 'ops', perms: ['p.walkin'] },
  {
    key: 'checkin',
    path: '/handover',
    label: 'تسليم سيارة',
    icon: 'key',
    group: 'ops',
    perms: ['p.checkin'],
  },
  {
    key: 'checkout',
    path: '/return',
    label: 'استلام سيارة',
    icon: 'ret',
    group: 'ops',
    perms: ['p.checkout'],
  },
  {
    key: 'customers',
    path: '/customers',
    label: 'الزبائن',
    icon: 'users',
    group: 'ops',
    perms: ['p.calendar', 'p.vouchers'],
  },
  {
    key: 'overview',
    path: '/overview',
    label: 'لوحة اليوم',
    icon: 'grid',
    group: 'mgmt',
    perms: ['p.overview'],
  },
  { key: 'finance', path: '/finance', label: 'الأرباح', icon: 'chart', group: 'mgmt', perms: ['p.finance'] },
  {
    key: 'reports',
    path: '/reports',
    label: 'التقارير والفواتير',
    icon: 'receipt',
    group: 'mgmt',
    perms: ['p.reports'],
  },
  {
    key: 'vouchers',
    path: '/credits',
    label: 'الأرصدة والقسائم',
    icon: 'wallet',
    group: 'mgmt',
    perms: ['p.vouchers'],
  },
  { key: 'fleet', path: '/fleet', label: 'الأسطول', icon: 'car', group: 'mgmt', perms: ['p.fleet'] },
  { key: 'team', path: '/team', label: 'الفريق والصلاحيات', icon: 'users', group: 'mgmt', perms: ['p.team'] },
  {
    key: 'pricing',
    path: '/pricing',
    label: 'الأسعار والإعدادات',
    icon: 'tag',
    group: 'mgmt',
    perms: ['p.pricing'],
  },
  {
    key: 'content',
    path: '/content',
    label: 'محتوى الموقع',
    icon: 'edit',
    group: 'mgmt',
    perms: ['p.content'],
  },
];

export const NAV_GROUP_LABEL: Record<NavGroup, string> = { ops: 'العمليات', mgmt: 'الإدارة' };
